<template>
    <button
        class="relative items-center gap-x-1 lg:flex"
        :aria-label="ariaLabel"
        @click="onClick"
    >
        <SvgIcon
            :name="iconName"
            class="text-muval-gray-1 hover:text-muval-gray-2 size-6"
        />
        <div
            v-show="notificationCount > 0"
            class="absolute -top-3 -right-3"
        >
            <span
                :class="[
                    'bg-brand z-1 flex items-center justify-center text-xs text-white',
                    notificationCount >= 100 ? 'h-[18px] min-w-[24px] rounded-full px-1' : 'size-[22px] rounded-full',
                ]"
                v-text="notificationCount"
            />
        </div>
    </button>
</template>

<script setup>
import { useAppStore } from '@store/app';
import { useNotificationsStore } from '@store/notifications';
import { useUserStore } from '@store/user';

const props = defineProps({
    scope: {
        type: String,
        default: 'main',
        validator: (value) => ['main', 'visitor'].includes(value),
    },
});

const app = useAppStore();
const notifications = useNotificationsStore();
const userStore = useUserStore();

const isVisitor = computed(() => props.scope === 'visitor');

const notificationCount = computed(() => {
    return isVisitor.value ? notifications.getVisitorUnreadCount : notifications.getUnreadCount;
});

const ariaLabel = computed(() => (isVisitor.value ? 'Visitor activity' : 'Notifications'));
const iconName = computed(() => (isVisitor.value ? 'system-customer-activity' : 'system-notification-filled'));

const onClick = () => {
    if (isVisitor.value) {
        app.toggleVisitorNotificationSlider();
    } else {
        app.toggleNotificationSlider();
    }
};

onMounted(() => {
    if (userStore.isCentralContext) {
        return;
    }

    if (isVisitor.value) {
        notifications.fetchUnreadCount('visitor');
        return;
    }

    notifications.startListener();
    notifications.fetchUnreadCount();
});
</script>
